import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-denied',
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.scss'],
  standalone: false,
})
export class PermissionDeniedPageComponent {}
